// @ts-check

// Vendor imports
const React = require('react')

const IS_SSR = typeof window === 'undefined'

/**
 * `React.useEffect`, but not during server-side rendering.
 * @see https://reactjs.org/docs/hooks-reference.html#useeffect
 *
 * @param {React.EffectCallback} effect
 * @param {React.DependencyList} [deps]
 * @returns {void}
 */
function useClientEffect(effect, deps) {
  React.useEffect(
    () => {
      if (!IS_SSR) {
        return effect()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps
  )
}

module.exports = useClientEffect
